<template>
  <div>
    <!-- Dialog 1 -->
    <v-dialog
      v-if="dialogsStore.openDialog1 && dialogsStore.openDialog1.open"
      :key="'dlg1-' + (dialogsStore.openDialog1?.module ?? '') + '-' + (dialogsStore.openDialog1?.id ?? '')"
      v-model="dialogsStore.openDialog1.open"
      fullscreen
      persistent
    >
      <component
        v-if="getDetailComponent(dialogsStore.openDialog1?.module)"
        :is="getDetailComponent(dialogsStore.openDialog1.module)"
        v-bind="dialogsStore.openDialog1.props"
        @close="dialogsStore.closeBy(dialogsStore.openDialog1.module, dialogsStore.openDialog1.id)"
      />
      <div v-else>
        No se encontró el componente detalle de "{{ dialogsStore.openDialog1?.module }}"
      </div>
    </v-dialog>

    <!-- Dialog 2 -->
    <v-dialog
      v-if="dialogsStore.openDialog2 && dialogsStore.openDialog2.open"
      :key="'dlg2-' + (dialogsStore.openDialog2?.module ?? '') + '-' + (dialogsStore.openDialog2?.id ?? '')"
      v-model="dialogsStore.openDialog2.open"
      fullscreen
      persistent
    >
      <component
        v-if="getDetailComponent(dialogsStore.openDialog2?.module)"
        :is="getDetailComponent(dialogsStore.openDialog2.module)"
        v-bind="dialogsStore.openDialog2.props"
        @close="dialogsStore.closeBy(dialogsStore.openDialog2.module, dialogsStore.openDialog2.id)"
      />
      <div v-else>
        No se encontró el componente detalle de "{{ dialogsStore.openDialog2?.module }}"
      </div>
    </v-dialog>

    <!-- Dialog 3 -->
    <v-dialog
      v-if="dialogsStore.openDialog3 && dialogsStore.openDialog3.open"
      :key="'dlg3-' + (dialogsStore.openDialog3?.module ?? '') + '-' + (dialogsStore.openDialog3?.id ?? '')"
      v-model="dialogsStore.openDialog3.open"
      fullscreen
      persistent
    >
      <component
        v-if="getDetailComponent(dialogsStore.openDialog3?.module)"
        :is="getDetailComponent(dialogsStore.openDialog3.module)"
        v-bind="dialogsStore.openDialog3.props"
        @close="dialogsStore.closeBy(dialogsStore.openDialog3.module, dialogsStore.openDialog3.id)"
      />
      <div v-else>
        No se encontró el componente detalle de "{{ dialogsStore.openDialog3?.module }}"
      </div>
    </v-dialog>
  </div>
</template>

<script setup lang="ts">
import { useDialogsStore } from '@/store/dialogs';
import { defineAsyncComponent } from 'vue';
import { configRegistry } from '@/lib/configRegistry';

const dialogsStore = useDialogsStore();

function getDetailComponent(moduleName?: string) {
  if (!moduleName) return null;
  const loader = configRegistry[moduleName];
  if (loader) {
    return defineAsyncComponent(async () => {
      const mod = await loader();
      return mod?.DETAIL?.component;
    });
  }
  return null;
}
</script>
